import axios from 'axios'
import {BASE_URL} from './env';

import {authHeader} from './_helpers/auth-header'

export default axios.create({
    baseURL: BASE_URL,
    headers: authHeader()
})
